export default "__VITE_ASSET__Dtrh7IaR__"